import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useQuery } from '@office-start/data-fetching';
import { useEdgeworthConfig } from '@office-start/edgeworth-config-service';
import { useIdentity } from '@office-start/identity-service';
import { getUserItem } from '@office-start/web-storage-utility';
import { favoritesQueryKey } from '../models/Constants';
import { getCachedSyncTimestampStorageKey } from '../operations/EdgeworthDb';
import { fetchFavorites } from '../operations/fetchFavorites';
import { getFavoritesRequestApiOptions } from '../utilities/RequestUtilities';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useEdgeworthFavorites() {
    var storageKey = getCachedSyncTimestampStorageKey();
    var context = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var config = useEdgeworthConfig().data;
    var storageValue = identity &&
        storageKey &&
        getUserItem(identity.puid, storageKey);
    return useQuery(favoritesQueryKey, function () {
        var _a;
        var currentPage = ((_a = context === null || context === void 0 ? void 0 : context.router) === null || _a === void 0 ? void 0 : _a.getCurrentPageForLogging())
            ? context.router.getCurrentPageForLogging()
            : '';
        var apiOptions = getFavoritesRequestApiOptions(
        /* eslint-disable @typescript-eslint/no-non-null-assertion */
        config, context, identity, 
        /* eslint-enable @typescript-eslint/no-non-null-assertion */
        currentPage);
        return fetchFavorites(apiOptions);
    }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        enabled: !!(context && config && identity) && !storageValue,
        refetchOnWindowFocus: false,
    });
}
//# sourceMappingURL=useEdgeworthFavorites.js.map